(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("gigyaWrapper", [], factory);
	else if(typeof exports === 'object')
		exports["gigyaWrapper"] = factory();
	else
		root["gigyaWrapper"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/